import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async inviteInternal(variables) {
		const res = await gql({
			query: mutation.inviteInternal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithoutStatus",
			res,
			resKey: "inviteInternal"
		})
	},

	async createOrganization(variables) {
		const res = await gql({
			query: mutation.createOrganization,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createOrganization"
		})
	},

	async updateOrganization(variables) {
		const res = await gql({
			query: mutation.updateOrganization,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateOrganization"
		})
	},

	async deleteOrganization(variables) {
		const res = await gql({
			query: mutation.deleteOrganization,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteEntity"
		})
	},

	async updateInternal(variables) {
		const res = await gql({
			query: mutation.updateInternal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateInternal"
		})
	},

	async unlockLogin(variables) {
		const res = await gql({
			query: mutation.updateLoginLockoutEndDate,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateLoginLockoutEndDate"
		})
	},

	async deleteLogin(variables) {
		const res = await gql({
			query: mutation.deleteLogin,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteLogin"
		})
	},

	async deletePermissionGroup(variables) {
		const res = await gql({
			query: mutation.deletePermissionGroup,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deletePermissionGroup"
		})
	},

	async addLink(variables) {
		const res = await gql({
			query: mutation.addLink,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addLink"
		})
	},

	async assignRole(variables) {
		const res = await gql({
			query: mutation.assignRole,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addToPermissionGroup"
		})
	},

	async removeRole(variables) {
		const res = await gql({
			query: mutation.removeRole,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeFromPermissionGroup"
		})
	},

	async resendConfirmationEmail(variables) {
		const res = await gql({
			query: mutation.resendConfirmationEmail,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "resendConfirmationEmail"
		})
	},

	// TODO: do we need?
	// async readAll(variables) {
	//   const res = await gql({
	//     query: query.readAll,
	//     variables,
	//   })

	//   return resolveApiErrors({
	//     resolutionType: "queryWithList",
	//     res,
	//     resKey: "internals",
	//   })
	// },

	async readAllInternals(variables) {
		const res = await gql({
			query: query.readAllInternals,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "internals"
		})
	},

	async internal(variables) {
		const res = await gql({
			query: query.internal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "internals"
		})
	},

	async removeLink(variables) {
		const res = await gql({
			query: mutation.removeLink,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeLink"
		})
	},

	async createInternal(variables) {
		const res = await gql({
			query: mutation.createInternal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createInternal"
		})
	},

	async readAllPermissions(variables) {
		const res = await gql({
			query: query.readAllPermissions,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "permissions"
		})
	},

	async readAllPermissionGroups(variables) {
		const res = await gql({
			query: query.readAllPermissionGroups,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "permissionGroups"
		})
	},

	async createPermissionGroup(variables) {
		const res = await gql({
			query: mutation.createPermissionGroup,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createPermissionGroup"
		})
	},

	async addPermissionToPermissionGroup(variables) {
		const res = await gql({
			query: mutation.addPermissionToPermissionGroup,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addPermissionToPermissionGroup"
		})
	},

	async addInheritedLoginToLogin(variables) {
		const res = await gql({
			query: mutation.addInheritedLoginToLogin,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addInheritedLoginToLogin"
		})
	},

	async removeInheritedLoginFromLogin(variables) {
		const res = await gql({
			query: mutation.removeInheritedLoginFromLogin,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeInheritedLoginFromLogin"
		})
	},

	async removePermissionFromPermissionGroup(variables) {
		const res = await gql({
			query: mutation.removePermissionFromPermissionGroup,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removePermissionFromPermissionGroup"
		})
	},

	async readAllOrganizations(variables) {
		const res = await gql({
			query: query.readAllOrganizations,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "organizations"
		})
	},

	async organizationsWithLogins(variables) {
		const res = await gql({
			query: query.organizationsWithLogins,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "organizations"
		})
	},

	async readAllLogins(variables) {
		const res = await gql({
			query: query.readAllLogins,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "logins"
		})
	}
}
